import { render } from "./NotificationsContainer.vue?vue&type=template&id=3de7a416&scoped=true"
import script from "./NotificationsContainer.vue?vue&type=script&lang=js"
export * from "./NotificationsContainer.vue?vue&type=script&lang=js"

import "./NotificationsContainer.vue?vue&type=style&index=0&id=3de7a416&lang=scss&scoped=true"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de7a416"]])

export default __exports__